export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.879 2.706a3 3 0 014.242 0l7.172 7.172a3 3 0 010 4.242l-7.172 7.172a3 3 0 01-4.242 0L9 20.413l-1.793 1.793a1 1 0 01-1.414 0L4.5 20.913l-1.293 1.293-1.414-1.414L3.086 19.5l-1.293-1.293a1 1 0 010-1.414L3.586 15l-.879-.879a3 3 0 010-4.242l7.172-7.172zm2.828 1.414a1 1 0 00-1.414 0l-7.172 7.172a1 1 0 000 1.414l7.172 7.172a1 1 0 001.414 0l7.172-7.172a1 1 0 000-1.414L12.707 4.12zM3.914 17.5L6.5 20.084 7.586 19 5 16.413 3.914 17.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};